module.exports = __webpack_public_path__ + "static/media/27.f6ae47cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/27.png
// module id = 987
// module chunks = 0